import { iZettleMarket, CountryIdUtil } from './countryId.js';

let Currency = /*#__PURE__*/function (Currency) {
  Currency["BRL"] = "BRL";
  Currency["DKK"] = "DKK";
  Currency["EUR"] = "EUR";
  Currency["GBP"] = "GBP";
  Currency["MXN"] = "MXN";
  Currency["NOK"] = "NOK";
  Currency["SEK"] = "SEK";
  Currency["USD"] = "USD";
  return Currency;
}({});
const currencyMap = {
  [iZettleMarket.GB]: Currency.GBP,
  [iZettleMarket.SE]: Currency.SEK,
  [iZettleMarket.DK]: Currency.DKK,
  [iZettleMarket.NO]: Currency.NOK,
  [iZettleMarket.FI]: Currency.EUR,
  [iZettleMarket.DE]: Currency.EUR,
  [iZettleMarket.ES]: Currency.EUR,
  [iZettleMarket.NL]: Currency.EUR,
  [iZettleMarket.FR]: Currency.EUR,
  [iZettleMarket.IT]: Currency.EUR,
  [iZettleMarket.MX]: Currency.MXN,
  [iZettleMarket.BR]: Currency.BRL,
  [iZettleMarket.US]: Currency.USD
};
const CurrencyUtil = {
  fromCountry: country => {
    if (!CountryIdUtil.isSupportedMarket(country)) {
      throw new Error(`'${country}' is not a supported market, could not get currency.`);
    }
    return currencyMap[country];
  }
};

export { Currency, CurrencyUtil };
//# sourceMappingURL=currency.js.map
